// import all exported methods from client.generated.ts into client namespace
import * as client from "./client.generated";

// export all types defined in client.generated.ts as if they were defined in api
export * from "./client.generated";

// export module client as default export
export default client;
